<template>
    <div class="item-card item-card--search" @click="handleClick">
        <!-- Delete -->
        <!-- <button type="button" class="btn btn-link btn-delete">
            <i class="fa fa-trash"></i>
        </button> -->

        <!-- Icon -->
        <i class="icon wa-icon-search"></i>

        <!-- Name -->
        <span class="name">
            {{ item.name }}
        </span>

        <!-- Travel period -->
        <small class="travel-period" v-if="item.travel_periods && item.travel_periods.length > 0">
            {{ $moment(item.travel_periods[0].date_from).format('DD.MM.') }}
            -
            {{ $moment(item.travel_periods[0].date_to).format('DD.MM.YYYY') }}
        </small>
    </div>
</template>

<script>
    export default {
        props: ['item'],
        data() {
            return {}
        },
        mounted() {},
        computed: {},
        methods: {
            handleClick() {
                this.$emit('click', this.item)
            },
        },
        watch: {}
    }
</script>
